import { Matter } from "./Matter";

export const custodyOrderTypes = {
  temporary: {
    label: "Temporary",
    color: "blue",
  },
  permanent: {
    label: "Permanent",
    color: "green",
  },
  stipulation: {
    label: "Stipulation",
    color: "yellow",
  },
  modification: {
    label: "Modification",
    color: "orange",
  },
};

export type CustodyOrderType = keyof typeof custodyOrderTypes;

export interface CustodyOrder {
  _id: string;
  title: string;
  description?: string;
  type: CustodyOrderType;
  orderDate: Date;
  matterId: Matter["_id"];
  blobName?: string;

  createdAt: Date;
  createdById: string;
  updatedAt?: Date;
  updatedBy?: string;
}
